import { LinkChip } from "@dealer-center/core-components";
import { useAccountHistory } from "@dealer-center/ddc-api-account-fetch";
import { useNavigate } from "react-router-dom";

interface NavLinkProps {
  accountID: string;
  component: string;
  testId?: string;
  sameWindow?: boolean;
  label: string;
  url: string;
}

export const NavLink = ({
  accountID,
  component,
  testId,
  sameWindow,
  label,
  url
}: NavLinkProps) => {
  const navigate = useNavigate();
  const { addToAccountHistory } = useAccountHistory();
  const htmlSafeAccountId = accountID.replace(/[^a-zA-Z0-9]/g, "");
  const testIdToUse = `${testId}account-link-${label}-${htmlSafeAccountId}`;
  return (
    <LinkChip
      analyticsConfiguration={{
        eventName: `Client Click ${label}`,
        eventProperties: {
          component,
          actionValue: accountID
        }
      }}
      data-testid={testIdToUse}
      label={label}
      sx={LinkChipSX}
      onClick={() => {
        addToAccountHistory(accountID);
        if (sameWindow) {
          navigate(url);
        } else {
          window.open(url, "_blank");
        }
      }}
    />
  );
};

const LinkChipSX: React.CSSProperties = {
  marginRight: "4px"
};
